import './Modal.css';
export default {
    "dialog": "Modal_dialog__1egrv",
    "backdrop": "Modal_backdrop__1egrv",
    "closeButton": "Modal_closeButton__1egrv",
    "container": "Modal_container__1egrv"
};
